/**
 * BLOCK - DISCOUNT CODE
 */

if (!customElements.get('discount-code')) {
  customElements.define('discount-code',
    class DiscountCode extends HTMLElement {
      constructor() {
        super();
        
        this.elements = {
          code: this.querySelector('[data-discount-code]'),
          initialText: this.querySelector('.initial-text'),
          copiedText: this.querySelector('.copied-text'),
          button: this.parentNode.querySelector('[data-action="copy-discount-code"]')
        };

        this.setupEventListeners();   
      }
    
      // Creates the event listeners
      setupEventListeners() {
        if (this.elements.code !== null) this.elements.code.addEventListener('click', this.onCodeClick.bind(this)); 
        if (this.elements.button !== null) this.elements.button.addEventListener('click', this.onButtonClick.bind(this));
      }
    
      // On clicking on a discount code
      onCodeClick(event) {
        var code = this.elements.code.getAttribute('data-discount-code');
        
        navigator.clipboard.writeText(code);
        
        if (this.elements.copiedText !== null) {
          this.elements.initialText.style.display = 'none';
          this.elements.initialText.style.opacity = 0;
          this.elements.copiedText.style.display = 'inline-block';
          this.elements.copiedText.style.opacity = 1;
          
          setTimeout(() => {
            this.elements.initialText.style.display = 'inline-block';
            this.elements.initialText.style.opacity = 1;
            this.elements.copiedText.style.display = 'none';
            this.elements.copiedText.style.opacity = 0;
          }, "2000");
        }
      }

      // On clicking on a button to copy code
      onButtonClick(event) {
        event.preventDefault();
        this.onCodeClick(event);
      }
    }
  );
}